var _defs, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _polygon, _polygon2, _polygon3, _polygon4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _rect27;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000.77 1001.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#939393;stroke-miterlimit:10;}.cls-2{fill:#e41e26;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 500.77,
    y1: 1000,
    x2: 500.77
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 250.77,
    y1: 1000,
    x2: 250.77
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 750.77,
    y1: 1000,
    x2: 750.77
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 875.77,
    y1: 1000,
    x2: 875.77
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 625.77,
    y1: 1000,
    x2: 625.77
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 375.77,
    y1: 1000,
    x2: 375.77
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 125.88,
    y1: 1000,
    x2: 125.88
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1000.77,
    y1: 499.2,
    x2: 0.77,
    y2: 499.2
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1000.77,
    y1: 624,
    x2: 0.77,
    y2: 624
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1000.26,
    y1: 374.4,
    x2: 0.77,
    y2: 374.4
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.77,
    y1: 249.6,
    x2: 1000.77,
    y2: 249.6
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.77,
    y1: 124.8,
    x2: 1000.77,
    y2: 124.8
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.77,
    y1: 748.8,
    x2: 1000.77,
    y2: 748.8
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.77,
    y1: 873.6,
    x2: 1000.77,
    y2: 873.6
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "126.61 624.76 187.83 375.85 250.92 500.39 250.95 500.45 500.06 251.39 438.39 749.22 126.61 624.76"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "251.09 126.93 187.83 317.9 748.79 193.53 251.09 126.93"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "499.88 566.75 688.03 694.37 624.36 500.54 625.12 500.14 874.24 375.11 499.06 375.11 499.88 566.75"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "748.79 749.22 685.83 560.92 874.24 691.49 874.24 874.71 499.88 874.71 748.79 749.22 748.79 749.22"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1.71,
    y: 123.47,
    width: 248.79,
    height: 2.25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.01,
    y: 314.48,
    width: 187.54,
    height: 2.07
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 749.48,
    y: 190.91,
    width: 250.49,
    height: 2.25
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 873.24,
    y: 372.61,
    width: 125.46,
    height: 4.11
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 624.29,
    y: 498.1,
    width: 375.67,
    height: 2.39
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 685.5,
    y: 558.38,
    width: 314.47,
    height: 3.73
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 874.89,
    y: 871.9,
    width: 125.88,
    height: 4.11
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.3,
    y: 622.21,
    width: 124.44,
    height: 4.11
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 687.26,
    y: 691.79,
    width: 313.51,
    height: 4.53
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 436.03,
    y: 933.98,
    width: 127.93,
    height: 4.11,
    transform: "translate(1436.8 436.03) rotate(90)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 346.17,
    y: 718.51,
    width: 307.66,
    height: 2.52,
    transform: "translate(1220.54 219.77) rotate(90)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 533.57,
    y: 844.91,
    width: 307.66,
    height: 2.52,
    transform: "translate(1534.34 158.78) rotate(90)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 373.78,
    y: 747.76,
    width: 502.44,
    height: 2.05,
    transform: "translate(1374.55 123.78) rotate(90)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -64.33,
    y: 811.55,
    width: 377.53,
    height: 2.95,
    transform: "translate(938.23 688.59) rotate(90)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 309.17,
    y: 871.86,
    width: 252.73,
    height: 3.54,
    transform: "translate(1309.94 438.1) rotate(90)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 435.9,
    y: 746.93,
    width: 312.35,
    height: 3.1,
    transform: "translate(1184.91 1496.96) rotate(180)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 720.89,
    y: 528.23,
    width: 308.22,
    height: 3.05,
    transform: "translate(1405.52 -345.25) rotate(90)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 716.57,
    y: 840.05,
    width: 316.86,
    height: 3.05,
    transform: "translate(1717.34 -33.43) rotate(90)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 654.55,
    y: 94.69,
    width: 190.91,
    height: 1.52,
    transform: "translate(846.22 -654.55) rotate(90)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 658.45,
    y: 281.17,
    width: 183.02,
    height: 2.5,
    transform: "translate(1033.14 -467.54) rotate(90)"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 436.92,
    y: 310.44,
    width: 124.06,
    height: 2.9,
    transform: "translate(811.39 -187.2) rotate(89.97)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 29.05,
    y: 157.32,
    width: 313.55,
    height: 2.5,
    transform: "translate(345.16 -27.26) rotate(90)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -0.77,
    y: 497.76,
    width: 250.78,
    height: 3.05,
    transform: "translate(250.01 998.58) rotate(180)"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -2.73,
    y: 748.22,
    width: 504.03,
    height: 3.11,
    transform: "translate(-499.72 999.07) rotate(-90)"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 156.16,
    y: 343.34,
    width: 59.32,
    height: 3.33,
    transform: "translate(531.59 159.17) rotate(90)"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 187.97,
    y: 61.69,
    width: 122.8,
    height: 3,
    transform: "translate(313.34 -186.18) rotate(90)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M97.31,142v-.51c0-6.35,2.86-11.52,10.75-17.27,5.15-3.76,6.71-5.06,6.71-8.25s-1.54-4.93-4.61-4.93c-3.57,0-4.86,2.18-5.36,5.36H97.14c.53-6.29,4.64-11.54,13-11.54,9.37,0,12.58,5.58,12.58,11,0,5.31-2.28,7.87-9,12.59-4.49,3.16-6.3,5.23-6.92,6.88h17.27l-1,6.62Z",
    transform: "translate(0.77)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M134.33,113.35c3,5.4,4.21,7.52,5.07,9h.06c1-1.74,2.73-4.9,5.06-9h8.82L144,127l9.27,15h-9c-2.58-4.86-4.19-8-5-9.65h-.06c-.76,1.51-2.72,5.23-5.07,9.65H125.5l8.88-14-8.83-14.71Z",
    transform: "translate(0.77)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.77,213.32V213c0-4.42,2-8,7.48-12,3.59-2.62,4.67-3.53,4.67-5.75s-1.07-3.43-3.2-3.43c-2.49,0-3.39,1.52-3.74,3.73H78.65c.37-4.38,3.23-8,9.07-8,6.52,0,8.76,3.88,8.76,7.69s-1.6,5.48-6.27,8.76c-3.13,2.2-4.39,3.65-4.82,4.79h12l-.69,4.61Z",
    transform: "translate(0.77)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.13,213.32v-19a17,17,0,0,1-4.59,1.1v-4.12a12,12,0,0,0,6.3-3.41h3.9v25.41Z",
    transform: "translate(0.77)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M124.27,215.29l10.68-29h4.58l-10.64,29Z",
    transform: "translate(0.77)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M142.5,213.32V213c0-4.42,2-8,7.49-12,3.58-2.62,4.67-3.53,4.67-5.75s-1.07-3.43-3.21-3.43c-2.49,0-3.38,1.52-3.73,3.73h-5.33c.36-4.38,3.23-8,9.06-8,6.53,0,8.76,3.88,8.76,7.69s-1.59,5.48-6.26,8.76c-3.14,2.2-4.39,3.65-4.83,4.79h12l-.69,4.61Z",
    transform: "translate(0.77)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M168.28,193.35c2.08,3.76,2.93,5.24,3.53,6.26h0c.69-1.21,1.9-3.41,3.53-6.26h6.14L175,202.86l6.46,10.46h-6.26c-1.79-3.38-2.92-5.57-3.5-6.71h0c-.53,1-1.89,3.64-3.53,6.71h-6l6.18-9.73-6.15-10.24Z",
    transform: "translate(0.77)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M107.38,246v-9.11a8.32,8.32,0,0,1-2.2.53v-2a5.69,5.69,0,0,0,3-1.64h1.88V246Z",
    transform: "translate(0.77)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M119.1,246v-9.11a8.49,8.49,0,0,1-2.21.53v-2a5.69,5.69,0,0,0,3-1.64h1.88V246Z",
    transform: "translate(0.77)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M124,246.92l5.12-13.9h2.2l-5.11,13.9Z",
    transform: "translate(0.77)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.73,246v-.17c0-2.12,1-3.85,3.59-5.77,1.72-1.26,2.24-1.69,2.24-2.76s-.51-1.65-1.54-1.65c-1.19,0-1.62.73-1.79,1.8h-2.56a4,4,0,0,1,4.35-3.86c3.13,0,4.21,1.87,4.21,3.69s-.77,2.63-3,4.21c-1.51,1.06-2.11,1.75-2.32,2.3h5.78l-.33,2.21Z",
    transform: "translate(0.77)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M145.1,236.38c1,1.81,1.41,2.52,1.7,3h0c.33-.58.91-1.64,1.69-3h3L148.35,241l3.1,5h-3c-.86-1.62-1.4-2.67-1.68-3.22h0c-.25.5-.9,1.75-1.69,3.22h-2.9l3-4.67-3-4.92Z",
    transform: "translate(0.77)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M312.44,243.53v-.17c0-2.12,1-3.85,3.6-5.77,1.72-1.25,2.24-1.69,2.24-2.75s-.51-1.65-1.54-1.65c-1.2,0-1.63.73-1.79,1.79h-2.56a4,4,0,0,1,4.35-3.86c3.13,0,4.2,1.87,4.2,3.69s-.76,2.64-3,4.21c-1.51,1.06-2.11,1.75-2.32,2.3h5.78l-.34,2.21Z",
    transform: "translate(0.77)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M329.43,243.53v-9.11a8.1,8.1,0,0,1-2.21.53v-2a5.69,5.69,0,0,0,3-1.64h1.87v12.2Z",
    transform: "translate(0.77)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M334.3,244.48l5.13-13.9h2.2l-5.11,13.9Z",
    transform: "translate(0.77)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M343.06,243.53v-.17c0-2.12.95-3.85,3.59-5.77,1.72-1.25,2.24-1.69,2.24-2.75s-.51-1.65-1.54-1.65c-1.19,0-1.62.73-1.79,1.79H343a4,4,0,0,1,4.35-3.86c3.13,0,4.21,1.87,4.21,3.69s-.77,2.64-3,4.21c-1.51,1.06-2.11,1.75-2.32,2.3H352l-.33,2.21Z",
    transform: "translate(0.77)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M355.43,233.94c1,1.81,1.41,2.52,1.7,3h0c.33-.58.91-1.64,1.69-3h3l-3.11,4.57,3.1,5h-3c-.86-1.62-1.4-2.67-1.68-3.22h0c-.25.5-.9,1.75-1.69,3.22h-2.9l3-4.67-2.95-4.92Z",
    transform: "translate(0.77)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M195.45,355.63V342a12.07,12.07,0,0,1-3.29.79v-3a8.66,8.66,0,0,0,4.52-2.45h2.8v18.26Z",
    transform: "translate(0.77)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M202.74,357l7.68-20.81h3.29L206.06,357Z",
    transform: "translate(0.77)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M215.85,355.63v-.26c0-3.17,1.42-5.76,5.37-8.63,2.58-1.89,3.36-2.54,3.36-4.13s-.77-2.47-2.31-2.47c-1.78,0-2.43,1.09-2.68,2.68h-3.83c.26-3.15,2.32-5.77,6.51-5.77,4.69,0,6.3,2.79,6.3,5.53s-1.15,3.94-4.5,6.29c-2.25,1.58-3.16,2.62-3.47,3.45h8.64l-.49,3.31Z",
    transform: "translate(0.77)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M234.37,341.28c1.49,2.7,2.1,3.76,2.53,4.49h0c.5-.87,1.37-2.45,2.54-4.49h4.41l-4.66,6.83,4.64,7.52h-4.49c-1.29-2.43-2.1-4-2.52-4.83h0c-.38.76-1.36,2.62-2.53,4.83H230l4.44-7L230,341.28Z",
    transform: "translate(0.77)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.63,758.37V753H265.78v-4.55l10-14.06h5.69v14.38h2.9L283.9,753h-2.42v5.39Zm0-13.89c0-2.6,0-4.05.11-5.56a105.1,105.1,0,0,1-6.34,9.83h6.23Z",
    transform: "translate(0.77)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M290.8,739.49c2,3.56,2.77,5,3.34,5.92h0c.65-1.15,1.8-3.23,3.33-5.92h5.81l-6.12,9,6.1,9.89h-5.91c-1.7-3.19-2.76-5.26-3.32-6.34h0c-.5,1-1.79,3.44-3.34,6.34H285l5.85-9.2L285,739.49Z",
    transform: "translate(0.77)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M112.52,492.08v-.25c0-3.18,1.43-5.76,5.38-8.64,2.58-1.88,3.36-2.53,3.36-4.12s-.77-2.47-2.31-2.47c-1.78,0-2.43,1.09-2.68,2.68h-3.83c.26-3.15,2.32-5.77,6.51-5.77,4.69,0,6.3,2.79,6.3,5.52s-1.15,3.94-4.5,6.3c-2.25,1.58-3.16,2.62-3.47,3.44h8.64l-.49,3.31Z",
    transform: "translate(0.77)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M131.05,477.73c1.49,2.71,2.1,3.77,2.53,4.5h0c.49-.87,1.37-2.45,2.53-4.5h4.42l-4.66,6.83,4.64,7.52h-4.49c-1.29-2.43-2.1-4-2.52-4.82h0c-.38.76-1.36,2.62-2.53,4.82h-4.34l4.44-7-4.42-7.36Z",
    transform: "translate(0.77)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M847.45,203.08v-.51c0-6.35,2.86-11.52,10.75-17.27,5.15-3.76,6.71-5.06,6.71-8.25s-1.54-4.93-4.61-4.93c-3.57,0-4.86,2.18-5.36,5.36h-7.66c.53-6.29,4.65-11.54,13-11.54,9.37,0,12.58,5.58,12.58,11.05,0,5.31-2.28,7.87-9,12.59-4.49,3.16-6.3,5.23-6.92,6.88h17.27l-1,6.62Z",
    transform: "translate(0.77)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M884.47,174.39c3,5.4,4.21,7.52,5.07,9h.06c1-1.74,2.73-4.9,5.06-9h8.82L894.18,188l9.27,15h-9c-2.58-4.86-4.19-8-5-9.65h-.06c-.76,1.51-2.71,5.23-5.06,9.65h-8.68l8.88-14-8.83-14.71Z",
    transform: "translate(0.77)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M726.51,99.14V81.36a15.61,15.61,0,0,1-4.3,1V78.53a11.14,11.14,0,0,0,5.89-3.19h3.66v23.8Z",
    transform: "translate(0.77)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M736,101l10-27.11h4.29l-10,27.11Z",
    transform: "translate(0.77)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M753.08,99.14v-.33c0-4.14,1.86-7.51,7-11.26,3.36-2.45,4.37-3.3,4.37-5.38s-1-3.22-3-3.22c-2.33,0-3.17,1.43-3.5,3.5h-5c.34-4.1,3-7.52,8.49-7.52,6.11,0,8.2,3.64,8.2,7.2s-1.49,5.13-5.87,8.21c-2.93,2.06-4.1,3.41-4.51,4.48h11.26l-.64,4.32Z",
    transform: "translate(0.77)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M777.22,80.44c1.95,3.52,2.74,4.9,3.3,5.86h0c.64-1.14,1.78-3.2,3.3-5.86h5.75l-6.06,8.9,6,9.8h-5.86c-1.67-3.17-2.73-5.22-3.28-6.29h0c-.5,1-1.77,3.41-3.3,6.29h-5.66L777.25,90l-5.76-9.58Z",
    transform: "translate(0.77)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M728.81,288V270.46a15.27,15.27,0,0,1-4.24,1v-3.8a11,11,0,0,0,5.81-3.15H734V288Z",
    transform: "translate(0.77)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M738.16,289.79,748,263.08h4.22l-9.82,26.71Z",
    transform: "translate(0.77)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M755,288v-.33c0-4.08,1.83-7.4,6.9-11.09,3.31-2.41,4.31-3.25,4.31-5.3s-1-3.17-3-3.17c-2.29,0-3.12,1.41-3.44,3.45h-4.92c.33-4.05,3-7.41,8.36-7.41,6,0,8.08,3.58,8.08,7.09s-1.47,5.06-5.78,8.09c-2.89,2-4,3.36-4.45,4.42h11.1l-.64,4.25Z",
    transform: "translate(0.77)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M778.77,269.55c1.92,3.47,2.7,4.83,3.25,5.78h0c.63-1.12,1.75-3.15,3.25-5.78H791l-6,8.77,6,9.66h-5.77c-1.66-3.12-2.69-5.14-3.23-6.2h0c-.49,1-1.75,3.36-3.25,6.2h-5.58l5.71-9-5.68-9.45Z",
    transform: "translate(0.77)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.35,332.82V305.56a24.29,24.29,0,0,1-6.59,1.58v-5.92a17.1,17.1,0,0,0,9-4.9h5.6v36.5Z",
    transform: "translate(0.77)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M83.44,332.82v-9.73H92v9.73Z",
    transform: "translate(0.77)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.6,302.83H108c-.24,1.94-.86,5.45-1.11,6.94a10,10,0,0,1,6.56-1.94c7.2,0,11.25,5.19,11.25,12.13s-3.86,13.53-13.71,13.53c-7.21,0-12.51-3.69-13.32-10.22h7.91a5.28,5.28,0,0,0,5.58,4.14c3.76,0,5.57-2.77,5.57-6.8,0-3.81-1.4-6.51-5.59-6.51-3.39,0-4.77,1.48-5.59,3.64l-7.17-.92c1-4.63,2.54-15.46,3.14-20.46h22.21Z",
    transform: "translate(0.77)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M135.49,304.14c3,5.4,4.2,7.52,5.07,9h.05c1-1.74,2.74-4.9,5.07-9h8.82l-9.3,13.65,9.27,15h-9c-2.57-4.85-4.18-8-5-9.64h0c-.76,1.51-2.72,5.23-5.07,9.64h-8.68l8.89-14-8.83-14.71Z",
    transform: "translate(0.77)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M245.57,51c3,5.41,4.21,7.53,5.07,9h.06c1-1.73,2.73-4.9,5.06-9h8.82l-9.3,13.66,9.27,15h-9c-2.58-4.86-4.19-8-5-9.64h-.06c-.76,1.51-2.71,5.23-5.06,9.64h-8.68l8.88-14L236.79,51Z",
    transform: "translate(0.77)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M918.67,359.8c3,5.4,4.2,7.52,5.06,9h.06c1-1.74,2.73-4.9,5.07-9h8.81l-9.3,13.66,9.28,15h-9c-2.58-4.86-4.19-8-5-9.64h-.06c-.76,1.5-2.71,5.22-5.06,9.64h-8.68l8.88-14-8.83-14.71Z",
    transform: "translate(0.77)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M936,881c1.66,3,2.33,4.17,2.81,5h0c.55-1,1.52-2.71,2.81-5h4.88l-5.15,7.56,5.13,8.33h-5c-1.43-2.69-2.32-4.43-2.79-5.34h0c-.42.83-1.5,2.89-2.8,5.34h-4.81L936,889.1,931.15,881Z",
    transform: "translate(0.77)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M514.67,296.54c3,5.4,4.21,7.52,5.07,9h.06c1-1.74,2.73-4.9,5.07-9h8.81l-9.3,13.65,9.28,15h-9c-2.58-4.85-4.19-8-5-9.64h-.06c-.76,1.51-2.71,5.23-5.06,9.64h-8.68l8.88-14-8.83-14.71Z",
    transform: "translate(0.77)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.74,611.67c3,5.41,4.2,7.53,5.07,9h0c1-1.73,2.74-4.89,5.07-9h8.82l-9.31,13.66,9.28,15h-9c-2.57-4.86-4.19-8-5-9.64h-.05c-.76,1.51-2.72,5.23-5.07,9.64H49.9l8.88-14L50,611.67Z",
    transform: "translate(0.77)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M495.76,918.74c3,5.4,4.21,7.52,5.07,9h.06c1-1.74,2.73-4.9,5.06-9h8.82l-9.3,13.65,9.27,15h-9c-2.58-4.85-4.19-8-5-9.64h-.06c-.76,1.51-2.71,5.23-5.06,9.64h-8.68l8.88-14L487,918.74Z",
    transform: "translate(0.77)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M512.89,787.34c2.52,4.54,3.54,6.33,4.27,7.56h0c.83-1.46,2.3-4.12,4.26-7.56h7.42l-7.82,11.48,7.79,12.64H521.3c-2.17-4.08-3.52-6.72-4.23-8.11H517c-.64,1.27-2.28,4.4-4.26,8.11h-7.3l7.47-11.75-7.42-12.37Z",
    transform: "translate(0.77)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M509.8,686.1v-12a10.42,10.42,0,0,1-2.9.7v-2.61a7.52,7.52,0,0,0,4-2.15h2.47V686.1Z",
    transform: "translate(0.77)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M525.23,686.1v-12a10.42,10.42,0,0,1-2.9.7v-2.61a7.52,7.52,0,0,0,4-2.15h2.47V686.1Z",
    transform: "translate(0.77)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M531.65,687.35,538.41,669h2.9l-6.74,18.32Z",
    transform: "translate(0.77)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M543.19,686.1v-.22c0-2.8,1.26-5.07,4.74-7.6,2.26-1.66,3-2.24,3-3.64s-.67-2.17-2-2.17c-1.57,0-2.14,1-2.36,2.36h-3.37c.23-2.77,2-5.08,5.73-5.08,4.13,0,5.54,2.46,5.54,4.86s-1,3.47-4,5.55c-2,1.39-2.78,2.3-3,3H555l-.44,2.91Z",
    transform: "translate(0.77)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M559.5,673.47c1.32,2.38,1.85,3.31,2.23,4h0c.43-.77,1.2-2.16,2.23-4h3.89l-4.1,6,4.08,6.62h-4c-1.14-2.14-1.85-3.52-2.22-4.24h0c-.33.66-1.19,2.3-2.23,4.24h-3.82l3.91-6.15-3.89-6.48Z",
    transform: "translate(0.77)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M696.63,909.48v-.23c0-2.79,1.26-5.07,4.74-7.6,2.27-1.66,3-2.23,3-3.64s-.67-2.17-2-2.17c-1.58,0-2.14,1-2.37,2.36h-3.37c.23-2.77,2.05-5.08,5.74-5.08,4.12,0,5.54,2.46,5.54,4.86s-1,3.47-4,5.55c-2,1.39-2.77,2.31-3,3h7.61l-.43,2.92Z",
    transform: "translate(0.77)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M713,896.84c1.31,2.38,1.85,3.31,2.23,4h0c.44-.77,1.21-2.16,2.24-4h3.88l-4.1,6,4.09,6.63h-4c-1.14-2.14-1.85-3.53-2.22-4.25h0c-.34.66-1.2,2.3-2.23,4.25h-3.83l3.92-6.16-3.89-6.48Z",
    transform: "translate(0.77)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M699.36,727.82v-8.47a7.76,7.76,0,0,1-2.05.49V718a5.36,5.36,0,0,0,2.81-1.52h1.74v11.34Z",
    transform: "translate(0.77)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M703.89,728.7l4.76-12.93h2.05L706,728.7Z",
    transform: "translate(0.77)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M712,727.82v-.15c0-2,.89-3.58,3.34-5.37,1.6-1.17,2.09-1.58,2.09-2.56S717,718.2,716,718.2c-1.12,0-1.52.68-1.67,1.67H712a3.73,3.73,0,0,1,4-3.59c2.91,0,3.91,1.74,3.91,3.43s-.72,2.45-2.8,3.92c-1.4,1-2,1.62-2.15,2.14h5.36l-.3,2.05Z",
    transform: "translate(0.77)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M723.54,718.91c.93,1.68,1.31,2.34,1.58,2.79h0c.31-.54.85-1.52,1.58-2.79h2.74l-2.89,4.24,2.88,4.67h-2.79c-.8-1.51-1.3-2.48-1.57-3h0c-.24.46-.85,1.62-1.58,3h-2.7l2.77-4.34-2.75-4.57Z",
    transform: "translate(0.77)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M936.15,666.88c2,3.62,2.82,5,3.39,6h0c.66-1.17,1.84-3.29,3.4-6h5.91L942.65,676l6.22,10.07h-6c-1.73-3.25-2.81-5.35-3.38-6.46h0c-.51,1-1.82,3.51-3.4,6.46h-5.81l5.95-9.36-5.92-9.86Z",
    transform: "translate(0.77)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M885.09,612c2,3.62,2.82,5,3.4,6h0c.66-1.17,1.83-3.28,3.39-6h5.91l-6.23,9.15,6.21,10.08h-6c-1.72-3.26-2.8-5.36-3.37-6.47h0c-.5,1-1.82,3.51-3.39,6.47h-5.82l6-9.37L879.21,612Z",
    transform: "translate(0.77)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M932.27,534.3c2,3.62,2.81,5,3.39,6h0c.66-1.16,1.83-3.28,3.4-6H945l-6.23,9.15L945,553.52h-6c-1.72-3.25-2.8-5.36-3.37-6.46h0c-.51,1-1.83,3.5-3.4,6.46h-5.82l6-9.37-5.92-9.85Z",
    transform: "translate(0.77)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M896.9,503.64c2,3.62,2.81,5,3.39,6h0c.66-1.17,1.83-3.29,3.4-6h5.9l-6.23,9.15,6.22,10.08h-6c-1.72-3.26-2.8-5.36-3.37-6.47h0c-.51,1-1.83,3.51-3.4,6.47H891l6-9.37L891,503.64Z",
    transform: "translate(0.77)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M761.48,493.33v-.17c0-2.1.94-3.81,3.56-5.71,1.7-1.25,2.22-1.68,2.22-2.74s-.51-1.63-1.53-1.63c-1.18,0-1.61.72-1.77,1.77h-2.54a4,4,0,0,1,4.31-3.82c3.11,0,4.17,1.85,4.17,3.66s-.76,2.61-3,4.17c-1.49,1.05-2.09,1.74-2.29,2.28h5.72l-.33,2.19Z",
    transform: "translate(0.77)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M773.74,483.83c1,1.79,1.39,2.49,1.68,3h0c.32-.58.9-1.62,1.68-3H780L777,488.35l3.07,5h-3c-.85-1.61-1.39-2.65-1.67-3.19h0c-.26.5-.9,1.73-1.68,3.19h-2.88l2.94-4.63-2.92-4.87Z",
    transform: "translate(0.77)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M593.83,622.21V622c0-2.1.94-3.82,3.56-5.72,1.7-1.25,2.22-1.68,2.22-2.73s-.51-1.64-1.53-1.64c-1.18,0-1.61.73-1.77,1.78h-2.54a4,4,0,0,1,4.31-3.82c3.11,0,4.17,1.85,4.17,3.66s-.76,2.61-3,4.17c-1.49,1-2.09,1.73-2.29,2.27h5.72l-.33,2.2Z",
    transform: "translate(0.77)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M606.09,612.71c1,1.79,1.39,2.49,1.68,3h0c.32-.57.9-1.62,1.67-3h2.93l-3.09,4.52,3.08,5h-3c-.85-1.61-1.39-2.65-1.67-3.2h0c-.26.5-.9,1.74-1.68,3.2h-2.88l2.94-4.63-2.92-4.87Z",
    transform: "translate(0.77)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M594.54,847.9v-.17c0-2.1.94-3.81,3.56-5.72,1.7-1.24,2.22-1.67,2.22-2.73s-.51-1.63-1.53-1.63c-1.18,0-1.61.72-1.77,1.77h-2.54a4,4,0,0,1,4.31-3.82c3.11,0,4.17,1.85,4.17,3.66s-.76,2.61-3,4.17c-1.49,1-2.09,1.73-2.29,2.28h5.72l-.33,2.19Z",
    transform: "translate(0.77)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M606.8,838.4c1,1.79,1.39,2.49,1.68,3h0c.32-.58.9-1.63,1.67-3h2.93L610,842.92l3.08,5h-3c-.85-1.61-1.39-2.65-1.67-3.19h0c-.26.5-.9,1.73-1.68,3.19h-2.88l2.94-4.63-2.92-4.87Z",
    transform: "translate(0.77)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M760.6,686.11v-12a10.78,10.78,0,0,1-2.89.69v-2.6a7.53,7.53,0,0,0,4-2.15h2.46v16.05Z",
    transform: "translate(0.77)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M776,686.11v-12a10.76,10.76,0,0,1-2.9.69v-2.6a7.52,7.52,0,0,0,4-2.15h2.46v16.05Z",
    transform: "translate(0.77)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M782.41,687.35l6.74-18.29H792l-6.72,18.29Z",
    transform: "translate(0.77)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M793.92,686.11v-.23c0-2.79,1.25-5.06,4.72-7.59,2.27-1.65,3-2.22,3-3.62s-.67-2.18-2-2.18c-1.57,0-2.14,1-2.36,2.36h-3.37c.24-2.77,2-5.07,5.73-5.07,4.12,0,5.53,2.45,5.53,4.85s-1,3.47-4,5.54c-2,1.39-2.77,2.3-3,3h7.59l-.43,2.91Z",
    transform: "translate(0.77)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M810.19,673.49c1.32,2.38,1.85,3.31,2.23,4h0c.43-.77,1.2-2.16,2.22-4h3.88l-4.09,6,4.08,6.61h-3.95c-1.13-2.14-1.84-3.52-2.21-4.24h0c-.33.66-1.19,2.3-2.23,4.24h-3.81l3.9-6.15-3.88-6.47Z",
    transform: "translate(0.77)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M407.87,885v-.51c0-6.35,2.85-11.51,10.75-17.26,5.14-3.76,6.7-5.07,6.7-8.25s-1.53-4.94-4.6-4.94c-3.57,0-4.86,2.19-5.36,5.36H407.7c.53-6.29,4.64-11.53,13-11.53,9.37,0,12.58,5.58,12.58,11,0,5.31-2.29,7.88-9,12.59-4.5,3.16-6.3,5.24-6.92,6.88h17.27l-1,6.62Z",
    transform: "translate(0.77)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M444.89,856.34c3,5.41,4.2,7.53,5.07,9H450c1-1.73,2.74-4.89,5.07-9h8.82L454.6,870l9.27,15h-9c-2.58-4.86-4.19-8-5-9.64h-.05c-.76,1.51-2.72,5.23-5.07,9.64h-8.68l8.89-14-8.83-14.71Z",
    transform: "translate(0.77)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M590.31,740.41v-.25c0-3.12,1.41-5.66,5.29-8.49,2.53-1.84,3.3-2.49,3.3-4s-.76-2.43-2.27-2.43c-1.75,0-2.39,1.08-2.63,2.64h-3.77c.26-3.1,2.28-5.67,6.4-5.67,4.61,0,6.19,2.74,6.19,5.42s-1.13,3.88-4.43,6.2c-2.21,1.55-3.1,2.57-3.4,3.38h8.49l-.48,3.25Z",
    transform: "translate(0.77)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M615.29,740.41V727a12.17,12.17,0,0,1-3.24.78v-2.92a8.45,8.45,0,0,0,4.45-2.4h2.75v17.94Z",
    transform: "translate(0.77)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M622.46,741.8,630,721.35h3.23l-7.51,20.45Z",
    transform: "translate(0.77)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M635.33,740.41v-.25c0-3.12,1.41-5.66,5.29-8.49,2.53-1.84,3.3-2.49,3.3-4s-.76-2.43-2.27-2.43c-1.75,0-2.39,1.08-2.63,2.64h-3.77c.26-3.1,2.28-5.67,6.4-5.67,4.61,0,6.19,2.74,6.19,5.42s-1.13,3.88-4.43,6.2c-2.21,1.55-3.1,2.57-3.4,3.38h8.49l-.48,3.25Z",
    transform: "translate(0.77)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M653.54,726.31c1.47,2.65,2.07,3.7,2.49,4.42h0c.48-.86,1.34-2.41,2.49-4.42h4.34L658.31,733l4.56,7.39h-4.42c-1.26-2.38-2.06-3.93-2.47-4.74h0c-.37.75-1.33,2.57-2.49,4.74h-4.27l4.37-6.87-4.34-7.23Z",
    transform: "translate(0.77)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M104.16,795c.51-4.49,3.67-10,12.79-10,8.45,0,12.2,4.78,12.2,9.92a7.66,7.66,0,0,1-4.51,7.41v.16c2.36.87,5.93,3.13,5.93,8.79,0,5.27-3.2,11.51-13.68,11.51-9.77,0-13.09-5.89-13.46-10.72h7.71c.49,2.49,2.21,4.65,6,4.65s5.48-2.36,5.48-5.57c0-3.38-1.72-5.42-6-5.42h-3.28v-6.11h2.89c3.64,0,5.11-1.2,5.11-4.26,0-2.51-1.49-4.19-4.64-4.19-3.7,0-4.58,2.06-5,3.87Z",
    transform: "translate(0.77)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M141.39,793.4c3,5.4,4.2,7.53,5.07,9h0c1-1.73,2.74-4.89,5.07-9h8.82l-9.3,13.66,9.27,15h-9c-2.58-4.86-4.19-8-5-9.64h0c-.76,1.51-2.72,5.23-5.07,9.64h-8.68l8.89-14-8.83-14.71Z",
    transform: "translate(0.77)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M892.49,480.54V466.41a12.37,12.37,0,0,1-3.42.82v-3.07a8.92,8.92,0,0,0,4.69-2.53h2.9v18.91Z",
    transform: "translate(0.77)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M910.64,480.54V466.41a12.37,12.37,0,0,1-3.42.82v-3.07a8.92,8.92,0,0,0,4.69-2.53h2.9v18.91Z",
    transform: "translate(0.77)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M918.19,482l7.94-21.55h3.42L921.62,482Z",
    transform: "translate(0.77)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M931.76,480.54v-.26c0-3.29,1.48-6,5.57-8.95,2.67-1.95,3.47-2.62,3.47-4.27s-.79-2.56-2.38-2.56c-1.85,0-2.52,1.13-2.78,2.78h-4c.27-3.26,2.41-6,6.75-6,4.85,0,6.52,2.89,6.52,5.72s-1.19,4.08-4.67,6.53c-2.33,1.63-3.26,2.71-3.58,3.56h8.95l-.52,3.43Z",
    transform: "translate(0.77)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M950.94,465.68c1.55,2.8,2.18,3.89,2.63,4.65h0l2.62-4.65h4.57L956,472.75l4.81,7.79h-4.66c-1.33-2.52-2.17-4.14-2.6-5h0c-.4.79-1.41,2.71-2.63,5h-4.49l4.6-7.24-4.58-7.62Z",
    transform: "translate(0.77)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M744.48,547.58V533.45a12.22,12.22,0,0,1-3.41.82V531.2a8.89,8.89,0,0,0,4.68-2.53h2.91v18.91Z",
    transform: "translate(0.77)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M762.63,547.58V533.45a12.22,12.22,0,0,1-3.41.82V531.2a8.89,8.89,0,0,0,4.68-2.53h2.91v18.91Z",
    transform: "translate(0.77)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M770.18,549l8-21.55h3.41L773.62,549Z",
    transform: "translate(0.77)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M783.76,547.58v-.26c0-3.29,1.48-6,5.57-9,2.66-2,3.47-2.62,3.47-4.27s-.8-2.56-2.38-2.56c-1.86,0-2.52,1.13-2.78,2.78h-4c.27-3.26,2.4-6,6.75-6,4.85,0,6.51,2.89,6.51,5.72s-1.18,4.08-4.66,6.53c-2.33,1.63-3.27,2.71-3.59,3.56h9l-.51,3.43Z",
    transform: "translate(0.77)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M802.94,532.72c1.55,2.79,2.18,3.89,2.63,4.65h0c.52-.9,1.42-2.53,2.63-4.65h4.57L808,539.79l4.8,7.79h-4.65c-1.34-2.52-2.17-4.14-2.61-5h0c-.39.79-1.4,2.71-2.62,5h-4.5l4.6-7.24-4.57-7.62Z",
    transform: "translate(0.77)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M891.21,798.86v-.31c0-3.76,1.69-6.82,6.38-10.23,3-2.24,4-3,4-4.9s-.91-2.92-2.73-2.92c-2.12,0-2.88,1.29-3.18,3.17h-4.54c.31-3.73,2.75-6.84,7.72-6.84,5.56,0,7.46,3.31,7.46,6.55s-1.35,4.68-5.33,7.47c-2.67,1.87-3.74,3.11-4.11,4.08h10.24l-.58,3.93Z",
    transform: "translate(0.77)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M921.33,798.86V782.68a14,14,0,0,1-3.91.94v-3.51a10.11,10.11,0,0,0,5.36-2.9h3.33v21.65Z",
    transform: "translate(0.77)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M930,800.53l9.1-24.66H943l-9.07,24.66Z",
    transform: "translate(0.77)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M945.5,798.86v-.31c0-3.76,1.69-6.82,6.38-10.23,3-2.24,4-3,4-4.9s-.91-2.92-2.73-2.92c-2.12,0-2.88,1.29-3.18,3.17H945.4c.31-3.73,2.75-6.84,7.72-6.84,5.56,0,7.46,3.31,7.46,6.55s-1.35,4.68-5.33,7.47c-2.67,1.87-3.74,3.11-4.11,4.08h10.24l-.58,3.93Z",
    transform: "translate(0.77)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M967.46,781.84c1.77,3.21,2.49,4.46,3,5.33h0c.59-1,1.63-2.9,3-5.33h5.23l-5.52,8.1,5.5,8.92h-5.33c-1.52-2.88-2.48-4.75-3-5.72h0c-.45.89-1.62,3.1-3,5.72h-5.15l5.27-8.29-5.23-8.73Z",
    transform: "translate(0.77)"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.29,
    y: 248.71,
    width: 499.92,
    height: 2.31
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSquare);
export default __webpack_public_path__ + "static/media/logoSquare.d43185d5c08e03658ae7b072ae638590.svg";
export { ForwardRef as ReactComponent };